import { Card, Col, Flex, Row, Space, Tag, Typography } from 'antd';
import dayjs from 'dayjs';

export default function ObjectCard({ object, onClick }) {
  return (
    <Card title={object.name} hoverable onClick={onClick}>
      {
        object.equipmentCount?
        <>
        <p>Количество оборудования: {object.equipmentCount}</p>
        {
          object.equipmentCount == 0
          ?
          <></>
          :
          <p>Ближайшая проверка: {dayjs(object.nextCheckInDays).format('DD.MM.YYYY')}</p>
        }</>:
        <Typography>Добавьте оборудование</Typography>
      }
        
    </Card>
  );
}
